import { apiRequest } from '../utils/api';

export const getSettingsSection = async (section, propertyId = null) => {
  const suffix = propertyId ? `?propertyId=${encodeURIComponent(propertyId)}` : '';
  const response = await apiRequest(`/api/settings/${section}${suffix}`);
  return response?.data || {};
};

export const saveSettingsSection = async (section, data, propertyId = null) => {
  return apiRequest(`/api/settings/${section}`, {
    method: 'PUT',
    body: JSON.stringify({ data, propertyId })
  });
};
